import { TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import React, { Component } from "react";
import store from "../../redux/store";
class AssetProperty extends Component {
  propertyDataTypeList = store.getState().staticData.propertyDataTypeList;
  constructor(props) {
    super(props);
    const selectedPropertyDataType =
      props.data.propertyDataType ||
      this.propertyDataTypeList.find(
        (item) => item.type === props.data.type || item.name === props.data.type
      ) ||
      null;

    this.state = {
      id: props.data.id,
      index: props.index,
      key: props.key,
      action: props.action,
      name: props.data.name,
      type: props.data.type,
      value: props.data.value,
      onRowDelete: props.onRowDelete,
      onChange: props.onChange,
      callBack: props.callBack,
      propertyDataType: selectedPropertyDataType,
      dimension: {
        id: props.data.dimension?.id || props.data?.dimensionId || "",
        height:
          props.data?.dimension?.height || props.data?.dimensionHeight || "",
        width:
          props.data.dimension?.width || props.data?.dimensionWidth || "",
        breadth:
          props.data.dimension?.breadth || props.data?.dimensionBreadth || "",
        weight:
          props.data.dimension?.weight || props.data?.dimensionWeight || "",
        heightUom:
          props.data.dimension?.heightuom || props.data?.heightUom || null,
        widthUom:
          props.data.dimension?.widthuom || props.data?.widthUom || null,
        breadthUom:
          props.data.dimension?.breadthuom || props.data?.breadthUom || null,
        weightUom:
          props.data.dimension?.weightuom || props.data?.weightUom || null,
      },
    };
  }

  handlePropertyNameChange(e) {
    this.setState({
      name: e.target.value,
    });
  }

  handlePropertyTypeChange(e) {
    const selected = this.propertyDataTypeList.find(
      (item) => item.type === e.target.value || item.name === e.target.value
    );

    this.setState({
      type: e.target.value,
      propertyDataType: selected || null,
    });
  }

  handlePropertyValueChange(e) {
    this.setState({
      value: e.target.value,
    });
  }

  handleDimensionFieldChange(field, value) {
    this.setState((prevState) => ({
      dimension: {
        ...prevState.dimension,
        [field]: value,
      },
    }));
  }

  handleRemoveRow(e) {
    if (
      undefined !== this.state.onRowDelete &&
      null !== this.state.onRowDelete
    ) {
      this.state.onRowDelete(this.state);
    }
  }

  isDimensionType() {
    const typeValue = this.state.type || this.props.data?.type;
    if (!typeValue) {
      return false;
    }
    const stringValue =
      typeof typeValue === "string"
        ? typeValue
        : typeValue?.type || typeValue?.name || typeValue?.value || "";
    const normalized = stringValue.toString().trim().toLowerCase();
    return (
      normalized === "dimension" ||
      normalized === "assetdimension" ||
      normalized === "asset dimension" ||
      (normalized.includes("asset") && normalized.includes("dimension"))
    );
  }

  renderDimensionField() {
    return (
      <div style={{ width: "100%" }}>
        <div className="row mb-2">
          <div className="col-6 pe-1">
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Height"
              value={this.state.dimension?.height || ""}
              onChange={(e) => this.handleDimensionFieldChange("height", e.target.value)}
              type="number"
              className="textField"
              size="small"
            />
          </div>
          <div className="col-6 ps-1">
            <Autocomplete
              size="small"
              disableClearable
              options={this.props.uomList || []}
              value={this.state.dimension.heightUom || null}
              getOptionLabel={(option) => option?.namecode || ""}
              onChange={(event, value) => {
                this.handleDimensionFieldChange("heightUom", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="form-control"
                  variant="outlined"
                  placeholder="UOM"
                  size="small"
                />
              )}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-6 pe-1">
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Width"
              value={this.state.dimension.width || ""}
              onChange={(e) => this.handleDimensionFieldChange("width", e.target.value)}
              type="number"
              className="textField"
              size="small"
            />
          </div>
          <div className="col-6 ps-1">
            <Autocomplete
              size="small"
              disableClearable
              options={this.props.uomList || []}
              value={this.state.dimension.widthUom || null}
              getOptionLabel={(option) => option?.namecode || ""}
              onChange={(event, value) => {
                this.handleDimensionFieldChange("widthUom", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="form-control"
                  variant="outlined"
                  placeholder="UOM"
                  size="small"
                />
              )}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-6 pe-1">
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Length"
              value={this.state.dimension.breadth || ""}
              onChange={(e) => this.handleDimensionFieldChange("breadth", e.target.value)}
              type="number"
              className="textField"
              size="small"
            />
          </div>
          <div className="col-6 ps-1">
            <Autocomplete
              size="small"
              disableClearable
              options={this.props.uomList || []}
              value={this.state.dimension.breadthUom || null}
              getOptionLabel={(option) => option?.namecode || ""}
              onChange={(event, value) => {
                this.handleDimensionFieldChange("breadthUom", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="form-control"
                  variant="outlined"
                  placeholder="UOM"
                  size="small"
                />
              )}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6 pe-1">
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Weight"
              value={this.state.dimension.weight || ""}
              onChange={(e) => this.handleDimensionFieldChange("weight", e.target.value)}
              type="number"
              className="textField"
              size="small"
            />
          </div>
          <div className="col-6 ps-1">
            <Autocomplete
              size="small"
              disableClearable
              options={this.props.uomList || []}
              value={this.state.dimension.weightUom || null}
              getOptionLabel={(option) => option?.namecode || ""}
              onChange={(event, value) => {
                this.handleDimensionFieldChange("weightUom", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="form-control"
                  variant="outlined"
                  placeholder="UOM"
                  size="small"
                />
              )}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.action === "create") {
      return this.createPropertyDetails();
    } else if (this.state.action === "edit") {
      return this.editPropertyDetails();
    } else {
      return this.viewPropertyDetails();
    }
  }

  createPropertyDetails() {
    return (

      <tr>
        <td>{this.props.index + 1}</td>
        <td>
          <TextField
            fullWidth
            variant="outlined"
            id={"name" + this.state.index}
            value={this.state.name}
            placeholder="Name"
            onChange={this.handlePropertyNameChange.bind(this)}
            name="name"
            type="text"
            className="textField"
          />{" "}
        </td>
        <td>
          <FormControl variant="outlined" fullWidth size="small">
            <Select
              // labelId="occurrence-label"
              id={"type" + this.state.index}
              style={{ background: "#fff" }}
              value={this.state.type}
              placeholder="Type *"
              required
              onChange={(e) => {
                this.handlePropertyTypeChange(e);
              }}
            >
              {this.propertyDataTypeList.map((event, keyIndex) => {
                return (
                  <MenuItem key={event.type || keyIndex} value={event.type}>
                    {event.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </td>
        <td>
          {this.isDimensionType() ? (
            this.renderDimensionField()
          ) : (
            <TextField
              fullWidth
              variant="outlined"
              id={"value" + this.state.index}
              placeholder="Title"
              value={this.state.value}
              onChange={this.handlePropertyValueChange.bind(this)}
              name="name"
              type="text"
              className="textField"
            />
          )}
        </td>
        <td>
          <CloseIcon
            onClick={this.handleRemoveRow.bind(this)}
            style={{ cursor: "pointer" }}
          />
        </td>
      </tr>

    );
  }
  viewPropertyDetails() {
    return (

      <div className="row">
        <label
          className="col-sm-3 col-form-label fw-bold ps-2"
          htmlFor="basic-default-name"
          id="assetFormLabel"
        >
          {this.props.data.name}
        </label>

        {this.props.data.type == 'Dimension' && (
          <span className="col-sm-9" id="AssetCol">
            <strong>Dimension: </strong>
            <span style={{ marginLeft: 10 }}>Height: </span> {this.props.data.dimension?.height || ''} {this.props.data.dimension?.heightuom?.name || ""} &nbsp;
            <span style={{ marginLeft: 10 }}>Width: </span> {this.props.data.dimension?.width || ''} {this.props.data.dimension?.widthuom?.name || ""} &nbsp;
            <span style={{ marginLeft: 10 }}>Length: </span> {this.props.data.dimension?.breadth || ''} {this.props.data.dimension?.breadthuom?.name || ""} &nbsp;
            <span style={{ marginLeft: 10 }}>Weight: </span> {this.props.data.dimension?.weight || ''} {this.props.data.dimension?.weightuom?.name || ""}
          </span>
        )}

        <div className="col-sm-9" id="AssetCol">
          <span>{this.props.data.value}</span>
        </div>
      </div>

    );
  }

  editPropertyDetails() {
    return (

      <tr>
        <td>{this.props.index + 1}</td>
        <td>
          <TextField
            type="text"
            className="textField"
            fullWidth
            variant="outlined"
            id={"name" + this.state.index}
            value={this.state.name}
            placeholder="Name"
            onChange={this.handlePropertyNameChange.bind(this)}
            name="name"
          />{" "}
        </td>
        <td>
          <FormControl variant="outlined" fullWidth size="small">
            <Select
              // labelId="occurrence-label"
              id={"type" + this.state.index}
              style={{ background: "#fff" }}
              value={this.state.type}
              placeholder="Type *"
              required
              onChange={(e) => {
                this.handlePropertyTypeChange(e);
              }}
            >
              {this.propertyDataTypeList.map((event, keyIndex) => {
                return (
                  <MenuItem key={event.type || keyIndex} value={event.type}>
                    {event.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </td>
        <td>
          {this.isDimensionType() ? (
            this.renderDimensionField()
          ) : (
            <TextField
              fullWidth
              variant="outlined"
              id={"value" + this.state.index}
              placeholder="Title"
              value={this.state.value}
              onChange={this.handlePropertyValueChange.bind(this)}
              name="name"
              type="text"
              className="textField"
            />
          )}
        </td>
        <td>
          <CloseIcon
            onClick={this.handleRemoveRow.bind(this)}
            style={{ cursor: "pointer" }}
          />
        </td>
      </tr>

    );
  }
}

export default AssetProperty;
